/** Aviso local: un mensaje anterior se copió al borrador de una conversación (detail = conversationId). */
export const draftEvents = new EventTarget();
